import { useUpdate } from 'react-admin';
import { useGetAppConfig } from './useGetAppConfig';
import { useOnSettled } from './useOnSettled';
import { useCallback } from 'react';
import {
  Box,
  CircularProgress,
  Switch,
  Tooltip,
  IconButton,
  Typography,
} from '@mui/material';
import { Semaphore } from './Semaphore';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export const WebSessionNoteActions = () => {
  const [updateConfig, { isLoading: isUpdating }] = useUpdate(
    'therapistAppConfig',
    { id: 'current' },
  );

  const { remoteAppConfig, refetchAppConfig } = useGetAppConfig();
  const ff_web_magicEdit = remoteAppConfig?.ff_web_magicEdit;
  const ff_web_reprocessing = remoteAppConfig?.ff_web_reprocessing;

  const { onSettled: doSettled } = useOnSettled();

  const onSettled = useCallback(async () => {
    doSettled();
    await refetchAppConfig();
  }, [doSettled, refetchAppConfig]);

  const onSwitchWebMagicEdit = useCallback(async () => {
    await updateConfig(
      'therapistAppConfig',
      {
        id: 'current',
        data: {
          ff_web_magicEdit: ff_web_magicEdit ? 0 : 1,
        },
      },
      {
        onSettled,
      },
    );
  }, [updateConfig, onSettled, ff_web_magicEdit]);

  const onSwitchWebReprocessing = useCallback(async () => {
    await updateConfig(
      'therapistAppConfig',
      {
        id: 'current',
        data: {
          ff_web_reprocessing: ff_web_reprocessing ? 0 : 1,
        },
      },
      {
        onSettled,
      },
    );
  }, [updateConfig, onSettled, ff_web_reprocessing]);

  return (
    <Box marginTop="2rem">
      {isUpdating && (
        <Box marginBottom={1}>
          <CircularProgress size={14} />
        </Box>
      )}
      <Box
        display="flex"
        alignItems="center"
        gap={0.5}
        marginBottom={1}
      >
        <Typography variant="h6">Therapists web — Magic Edit</Typography>
        <Tooltip title="When enabled globally, therapists can use Magic Edit on session notes in therapists-web only. Can be overridden per therapist. Independent from mobile Magic Edit (ff_magicEdit).">
          <IconButton size="small" sx={{ padding: 0.5 }}>
            <HelpOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap={1}
        marginBottom={3}
      >
        <Switch
          checked={!!ff_web_magicEdit}
          onChange={onSwitchWebMagicEdit}
          disabled={isUpdating}
        />
        <Box display="flex" alignItems="center" gap={0.5}>
          {!isUpdating && <Semaphore enabled={!!ff_web_magicEdit} />}
        </Box>
      </Box>

      <Box
        display="flex"
        alignItems="center"
        gap={0.5}
        marginBottom={1}
      >
        <Typography variant="h6">Therapists web — Reprocess note</Typography>
        <Tooltip title="When enabled globally, therapists can reprocess session notes from therapists-web only. Can be overridden per therapist.">
          <IconButton size="small" sx={{ padding: 0.5 }}>
            <HelpOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
        <Switch
          checked={!!ff_web_reprocessing}
          onChange={onSwitchWebReprocessing}
          disabled={isUpdating}
        />
        <Box display="flex" alignItems="center" gap={0.5}>
          {!isUpdating && <Semaphore enabled={!!ff_web_reprocessing} />}
        </Box>
      </Box>
    </Box>
  );
};
